import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { openNewWindow } from "../../utils/helperUtils";
import styles from "../../styles/ProfilePaymentHistory.module.scss";
import isLoggingInFromClient from "../../selectors/isLoggingInFromClient";

export default function ProfilePaymentHistory(props) {
  const { invoices, fullPage } = props;
  const clientLoginState = useSelector(isLoggingInFromClient);

  function handleInvoiceClick(url) {
    if (clientLoginState) {
      openNewWindow(url, true);
    } else {
      window.open(url);
    }
  }

  function renderTable() {
    if (invoices.length !== 0) {
      return (
        <div className={styles.paymentHistoryWrapper}>
          <table className={styles.desktopTable}>
            <thead>
              <tr>
                <th>Invoice Number</th>
                <th>Product</th>
                <th>Invoice Date</th>
                <th>Amount</th>
                <th>Invoice</th>
              </tr>
            </thead>
            <tbody>{renderTableData()}</tbody>
          </table>
          <div className={styles.mobileTable}>{renderMobileTableData()}</div>
          {invoices.length > 4 && !fullPage && (
            <Link
              to="/account/subscription/history"
              className={styles.manageBtn}
            >
              Show All
            </Link>
          )}
        </div>
      );
    } else {
      return (
        <div className={styles.errorContainer}>
          <p>There is no current payment history</p>
        </div>
      );
    }
  }
  function renderTableData() {
    // eslint-disable-next-line
    return invoices.map((invoice, index) => {
      if (!fullPage && index <= 3) {
        return (
          <tr key={index}>
            <td>{invoice.id}</td>
            <td>{invoice.description}</td>
            <td>{invoice.paidAt}</td>
            <td>
              {invoice.currency} ${invoice.amountPaid}
            </td>
            <td>
              <button
                onClick={() => handleInvoiceClick(invoice.pdfUrl)}
                className={styles.invoiceUrl}
              >
                Download{" "}
                <img
                  src="https://frontend-assets.buildbox.com/Icon+PDF.png"
                  alt="payment-history-icon"
                  className={styles.pdfIcon}
                />
              </button>
            </td>
          </tr>
        );
      } else if (fullPage) {
        return (
          <tr key={index}>
            <td>{invoice.id}</td>
            <td>{invoice.description}</td>
            <td>{invoice.paidAt}</td>
            <td>
              {invoice.currency} ${invoice.amountPaid}
            </td>
            <td>
              <button
                onClick={() => handleInvoiceClick(invoice.pdfUrl)}
                className={styles.invoiceUrl}
              >
                Download{" "}
                <img
                  src="https://frontend-assets.buildbox.com/Icon+PDF.png"
                  alt="payment-history-icon"
                  className={styles.pdfIcon}
                />
              </button>
            </td>
          </tr>
        );
      }
    });
  }

  function renderMobileTableData() {
    if (invoices.length !== 0) {
      return invoices.map((invoice, index) => {
        if (!fullPage && index <= 3) {
          return (
            <div key={index} className={styles.invoiceDetails}>
              <div>
                <h6>Invoice Number</h6>
                <span>{invoice.invoiceId}</span>
              </div>
              <div>
                <h6>Product</h6>
                <span>{invoice.productName}</span>
              </div>
              <div>
                <h6>Invoice Date</h6>
                <span>{invoice.invoiceDate}</span>
              </div>
              <div>
                <h6>Amount</h6>
                <span>US ${invoice.amount}.00</span>
              </div>
              <div>
                <h6>Invoice</h6>
                <a href={invoice.invoiceURL} className={styles.invoiceUrl}>
                  Download{" "}
                  <img
                    src="https://frontend-assets.buildbox.com/Icon+PDF.png"
                    alt="payment-history-icon"
                    className={styles.pdfIcon}
                  />
                </a>
              </div>
            </div>
          );
        } else if (fullPage) {
          return (
            <div key={index} className={styles.invoiceDetails}>
              <div>
                <h6>Invoice Number</h6>
                <span>{invoice.invoiceId}</span>
              </div>
              <div>
                <h6>Product</h6>
                <span>{invoice.productName}</span>
              </div>
              <div>
                <h6>Invoice Date</h6>
                <span>{invoice.invoiceDate}</span>
              </div>
              <div>
                <h6>Amount</h6>
                <span>US ${invoice.amount}.00</span>
              </div>
              <div>
                <h6>Invoice</h6>
                <a href={invoice.invoiceURL} className={styles.invoiceUrl}>
                  Download{" "}
                  <img
                    src="https://frontend-assets.buildbox.com/Icon+PDF.png"
                    alt="payment-history-icon"
                    className={styles.pdfIcon}
                  />
                </a>
              </div>
            </div>
          );
        }
        else {
          return undefined
        }
      });
    }
  }

  return renderTable();
}
